export const labels = {
	title: {
		label: "Label.MobileCreator.Sidebar.TextColor.Title",
		default: "Text color",
	},
	recommendedColors: {
		label: "Label.MobileCreator.Sidebar.TextColor.RecommendedColors",
		default: "Recommended colors",
	},
	allColors: {
		label: "Label.MobileCreator.Sidebar.TextColor.AllColors",
		default: "All colors",
	},
};
